// extracted by mini-css-extract-plugin
module.exports = {"starButton":"_2cvkYnH-","unselectedStar":"_1FvjooZS"};